module.exports = __webpack_public_path__ + "static/Albertsons-53aa96c447ee7502c071ed3c71d9849a.jpeg";